import { DatePipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DsButtonComponent } from '@design-system/ds-button/component/ds-button.component';
import { DsTextareaComponent } from '@design-system/ds-textarea/component/ds-textarea.component';
import { ServiceRequestFlagPayload } from '@modals/service-request-flags/interfaces/service-request-flag.interface';

@Component({
  selector: 'app-flag-resolve',
  templateUrl: './flag-resolve.component.html',
  styleUrls: ['./flag-resolve.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, DatePipe, ReactiveFormsModule, MatInputModule, DsButtonComponent, DsTextareaComponent],
})
export class FlagResolveComponent {
  @Input() flag: ServiceRequestFlagPayload;
  @Input() createdBy = '';
  @Input() noteControl: FormControl<string | null>;
  @Input() isSaving = false;

  @Output() readonly resolve = new EventEmitter<void>();
  @Output() readonly cancel = new EventEmitter<void>();
}
